import React from 'react';
import { COLORS } from '../constants';

export const Loader = ({ label = 'Caricamento...' }) => (
  <div className="loader-screen" data-testid="app-loader">
    <img src="/images/beautykit-logo.png" alt="BeautyKit" className="loader-logo" />
    <div className="loader-dots">
      {Object.values(COLORS).map((c, i) => <span key={c} style={{ background: c, animationDelay: `${i * 0.12}s` }} />)}
    </div>
    <p className="loader-label">{label}</p>
  </div>
);

export default Loader;
